import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { NumberInput, CommonInputProps } from "react-admin";
import TextField from "@mui/material/TextField";
import { useFormContext } from "react-hook-form";
import lodashGet from "lodash/get";
import { RangeOutlineBox } from "../common/RangeOutlineBox";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

export const PriceRangeInput = (props: PriceRangeInputProps) => {
  const { label, source, alwaysOn, ...rest } = props;

  const form = useFormContext();
  const filterValues = form.getValues();

  const pricePattern = "[0-9]*.?[0-9]{0,2}";

  useEffect(() => {
    let filterValue = lodashGet(filterValues, source);

    if (
      typeof filterValue !== "undefined" &&
      filterValue != "" &&
      !Object.values(filterValue).some((v) => v)
    ) {
      form.setValue(source, "");
    }
  }, [filterValues]);

  const handleChange = (e) => {
    let { id, value } = e.target;
    let filterValue = lodashGet(filterValues, source);

    if (typeof filterValue === "undefined" || filterValue == "") {
      filterValue = {};
    }

    if (value == "") {
      delete filterValue[id];

      if (Object.keys(filterValue).length === 0) {
        filterValue = "";
      }
    } else {
      filterValue[id] = value * 100;
    }

    form.setValue(source, filterValue);
  };

  return (
    <React.Fragment>
      <RangeOutlineBox label={label}>
        <div>
          <AttachMoneyIcon
            fontSize={"medium"}
            sx={{
              marginTop: "17px",
              color: (theme) => theme.palette.grey["400"],
            }}
          />
          <TextField
            id="from"
            label={":from"}
            sx={styles}
            variant="outlined"
            inputProps={{ className: "input", pattern: pricePattern }}
            onChange={handleChange}
            {...rest}
          />
        </div>
        <div>
          <AttachMoneyIcon
            fontSize={"medium"}
            sx={{
              marginTop: "17px",
              color: (theme) => theme.palette.grey["400"],
            }}
          />
          <TextField
            id="to"
            label={":to"}
            sx={styles}
            variant="outlined"
            onChange={handleChange}
            inputProps={{ className: "input", pattern: pricePattern }}
            {...rest}
          />
        </div>
      </RangeOutlineBox>
    </React.Fragment>
  );
};

PriceRangeInput.propTypes = {
  filter: PropTypes.object,
  label: PropTypes.string,
  source: PropTypes.string,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export type PriceRangeInputProps = CommonInputProps & {
  label: string;
  source: string;
  step?: string | number;
  min?: string | number;
  max?: string | number;
};

const styles = {
  input: {
    "&:invalid": {
      color: "red",
    },
    width: "5em",
  },
};
